export default __webpack_public_path__ + "static/media/order2.2355f536.png";